"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Filter_1 = __importDefault(require("../Filter"));
var useGameSearch_1 = require("./useGameSearch");
var framer_motion_1 = require("framer-motion");
var OPEN_SEARCH_BY_TITLE = 'open_search_by_title';
var TopGamesInLocation = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var category = _a.category;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var config = (0, swr_hooks_1.useConfig)();
    var country = (_c = (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var data = (0, swr_hooks_1.useGamesByCategories)().data;
    var _j = (0, swr_hooks_1.useCache)(), getDataFromCache = _j.getDataFromCache, setDataToCache = _j.setDataToCache;
    var _k = (0, react_1.useState)(getDataFromCache(OPEN_SEARCH_BY_TITLE)), isSearch = _k[0], setIsSearch = _k[1];
    var _l = (0, useGameSearch_1.useGameSearch)({
        allowSearch: !!isSearch,
    }), searchValue = _l.searchValue, onLoadBtnClick = _l.onLoadBtnClick, onSearchClear = _l.onSearchClear, onFiltersClear = _l.onFiltersClear, onSearchChange = _l.onSearchChange, isSubmitting = _l.isSubmitting, searchResults = _l.searchResults, isShowLoadMore = _l.isShowLoadMore;
    var collectionIncludeGEO = (0, react_1.useMemo)(function () {
        var COLLECTION = category ? category : 'top';
        return (data === null || data === void 0 ? void 0 : data["".concat(COLLECTION, "_").concat(country)])
            ? "".concat(COLLECTION, "_").concat(country)
            : COLLECTION;
    }, [data, country, category]);
    var gamesCount = (0, react_1.useMemo)(function () {
        var _a, _b;
        var count = 10;
        if ((_a = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _a === void 0 ? void 0 : _a.homeTopInLocation) {
            var settings = (_b = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _b === void 0 ? void 0 : _b.homeTopInLocation;
            if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile384) || (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile460)) &&
                (settings === null || settings === void 0 ? void 0 : settings['xs']))
                count = settings === null || settings === void 0 ? void 0 : settings['xs'];
            else if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile550) ||
                (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile660) ||
                breakpoints.mobile767) &&
                (settings === null || settings === void 0 ? void 0 : settings['mobile']))
                count = settings === null || settings === void 0 ? void 0 : settings['mobile'];
            else if (breakpoints.tablet && (settings === null || settings === void 0 ? void 0 : settings['tablet']))
                return settings === null || settings === void 0 ? void 0 : settings['tablet'];
            else
                return settings['default'];
        }
        return count;
    }, [(_d = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _d === void 0 ? void 0 : _d.homeTopInLocation, breakpoints]);
    var games = ((_f = (_e = data === null || data === void 0 ? void 0 : data[collectionIncludeGEO]) === null || _e === void 0 ? void 0 : _e.previewGames) === null || _f === void 0 ? void 0 : _f.slice(0, gamesCount)) || [];
    var viewAllHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/".concat(collectionIncludeGEO)));
    }, [router, collectionIncludeGEO, generateUrlWithLang]);
    if (!(games === null || games === void 0 ? void 0 : games.length))
        return null;
    var visibleGames = isSearch ? searchResults : games;
    return (react_1.default.createElement("section", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("header", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("h1", null, category && ((_g = data === null || data === void 0 ? void 0 : data[collectionIncludeGEO]) === null || _g === void 0 ? void 0 : _g.title)
                ? translateLocale((_h = data === null || data === void 0 ? void 0 : data[collectionIncludeGEO]) === null || _h === void 0 ? void 0 : _h.title)
                : t('topGamesInYourLocation')),
            react_1.default.createElement(Filter_1.default, { search: true, title: t('search'), onClick: function () {
                    setIsSearch(function (prev) {
                        var next = !prev;
                        if (prev) {
                            onFiltersClear();
                        }
                        onSearchClear();
                        setDataToCache(OPEN_SEARCH_BY_TITLE, next);
                        return next;
                    });
                }, slug: "search", isActive: isSearch })),
        react_1.default.createElement(framer_motion_1.AnimatePresence, { initial: false }, isSearch && (react_1.default.createElement(framer_motion_1.motion.div, { key: "search-content", initial: { height: 0, opacity: 0 }, animate: { height: 'auto', opacity: 1 }, exit: { height: 0, opacity: 0 }, transition: { duration: 0.3, ease: 'easeInOut' }, style: { overflow: 'hidden' } },
            react_1.default.createElement(ui_components_1.SearchInput, { withClear: false, value: searchValue, onChange: onSearchChange, onClear: onSearchClear })))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.gameItemWrapper }, visibleGames.length === 0 ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (visibleGames === null || visibleGames === void 0 ? void 0 : visibleGames.map(function (item) {
            var _a;
            return (react_1.default.createElement(framer_motion_1.motion.div, { layout: true, transition: {
                    type: 'spring',
                    damping: 20,
                    stiffness: 300,
                }, key: "provider_page".concat(item.id, "}") }, Object.keys(breakpoints).length > 0 &&
                (breakpoints.mobile || breakpoints.tablet) ? (react_1.default.createElement(ui_components_1.MobileGameCard, { title: item.title, gameId: item.id, slug: item === null || item === void 0 ? void 0 : item.slug, gameCardPlaceholder: (config === null || config === void 0 ? void 0 : config.gameCardPlaceholder) || '', gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })) : (react_1.default.createElement(ui_components_1.DesktopGameCard, { title: item.title, gameId: item.id, slug: item.slug, withDemo: (_a = item === null || item === void 0 ? void 0 : item.settings) === null || _a === void 0 ? void 0 : _a['demo'], gameCardPlaceholder: (config === null || config === void 0 ? void 0 : config.gameCardPlaceholder) || '', signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL }))));
        }))),
        !isSearch && Boolean(games === null || games === void 0 ? void 0 : games.length) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper, onClick: viewAllHandler },
            react_1.default.createElement(ui_components_1.LoadMoreButton, null, t('viewAll')))),
        isShowLoadMore && isSearch && (react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper },
            react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: onLoadBtnClick }, t('loadMore')))),
        !isSubmitting && !searchResults.length && isSearch && (react_1.default.createElement("div", { className: styles_module_scss_1.default.gamesNotFound }, t('notFoundGamesByFilters')))));
};
exports.default = TopGamesInLocation;
